/**
 * Pages excluded from the sitemap and disallowed in robots.txt.
 * Also used in _app.js to inject <meta name="robots" content="noindex, nofollow">
 * on matching routes automatically.
 *
 * Patterns:
 *   "/foo"    → exact match
 *   "/foo/*"  → any path starting with /foo/
 *
 * NOTE:
 * - "/server-sitemap.xml" is intentionally NOT here — it must remain accessible to crawlers.
 * - Non-default locales (es-la, pt-br, it, fr, de, ru) are intentionally NOT here so they
 *   can be crawled, indexed, and referenced in server-sitemap.xml and hreflang tags.
 * - "/en" and "/en/*" are excluded because English is the default locale served at root "/",
 *   and Next.js redirects /en/* to /*.
 */
const nonDefaultLocales = ["ru", "es-la", "pt-br", "it", "fr", "de"];

const baseExcludedPaths = [
  "/sale",
  "/sale/*",
  "/hx50presentation",
  "/vip",
  "/configurator/*",
  "/schedule",
  "/subscription-preferences",
  "/tomcruise",
  "/update-sneakpeek",
  "/discount",
  "/visitors-info",
  "/direct-preorder",
  "/direct-call",
  "/direct-presentation",
  "/public-sale/*",
  "/internal",
  "/internal/*",
  "/skids",
  "/orders",
  "/pre-order",
  "/auth",
  "/live",
  "/home1",
  "/hx50digitalbooklet",
  "/meetings",
  "/newscoming",
  "/preorder",
  "/preorder-old",
  "/public-sale",
  "/public-sale/contract",
  "/404",
  "/book-presentation",
  "/fasttrack",
  "/gmde",
  "/discover",
  "/presentation-video",
  "/account/*",
  "/raisingthestandard",
  "/raisingthestandard-info",
  "/event-reg",
  "/event-reg-direct",
  "/video/*",
  "/rts",
  "/rts/*",
  "/sale-hx50",
  "/sale-hx50/*",
  "/sale-hc50",
  "/sale-hc50/*",
];

const excludedPaths = [
  "/en",
  "/en/*",
  ...baseExcludedPaths,
  ...nonDefaultLocales.flatMap((loc) =>
    baseExcludedPaths.map((path) => `/${loc}${path}`),
  ),
];

/**
 * Returns true if the given URL path matches any excluded pattern.
 * @param {string} asPath - router.asPath (e.g. "/en/some-page?foo=1")
 */
function isExcludedRoute(asPath) {
  const pathname = asPath.split("?")[0].split("#")[0];
  return excludedPaths.some((pattern) => {
    if (pattern.endsWith("/*")) {
      const prefix = pattern.slice(0, -2); // strip /*
      return pathname === prefix || pathname.startsWith(prefix + "/");
    }
    return pathname === pattern;
  });
}

module.exports = { excludedPaths, isExcludedRoute };
